import { render } from "./IndexCashRegister.vue?vue&type=template&id=5e6b54d5"
import script from "./IndexCashRegister.vue?vue&type=script&lang=js"
export * from "./IndexCashRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__